/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/assistant.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Who said it. TOOL is the tracker itself reporting what a tool returned.
 */

export const TrackerAssistantRole = {
  AssistantRoleUnspecified: 'ASSISTANT_ROLE_UNSPECIFIED',
  AssistantRoleUser: 'ASSISTANT_ROLE_USER',
  AssistantRoleAssistant: 'ASSISTANT_ROLE_ASSISTANT',
  AssistantRoleTool: 'ASSISTANT_ROLE_TOOL',
} as const

export type TrackerAssistantRole = (typeof TrackerAssistantRole)[keyof typeof TrackerAssistantRole]
